import { styled } from '@material-ui/core/styles';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';

import { ICustomTheme } from 'interfaces';

export const StyledBubble = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    height: 30,
    width: 30,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    color: theme.colors.white,
  }),
);

export const StyledVisibilityIcon = styled(VisibilityOutlinedIcon)(
  ({ theme }: { theme: ICustomTheme }) => ({
    height: 24,
    width: 24,
    marginRight: theme.spacing(1),
  }),
);
